import { render, staticRenderFns } from "./FloatingMenu.vue?vue&type=template&id=15fd14d3&"
import script from "./FloatingMenu.vue?vue&type=script&lang=js&"
export * from "./FloatingMenu.vue?vue&type=script&lang=js&"
import style0 from "./FloatingMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports